import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { SFStack } from "../../../grid";
import SFTypography from "../../../typography";
import { useSelector } from "react-redux";

const SFBottomStatusPanel = ({
  gridName,
  hasRowSelection,
  disableSelectedRowStatus = false,
  treeSelectionLabels = null,
}) => {
  const savedLayout = useSelector((state) => {
    return state.gridLayout.find(
      (gridLayout) => gridLayout.gridName === gridName,
    );
  });

  const { t } = useTranslation();

  return (
    <div className="ag-status-name-value">
      <SFStack direction="row" alignItems={"center"} spacing={2}>
        <SFTypography variant="body1bold">
          {t("components.datagrid.footer.results")} {savedLayout?.rowCount}
        </SFTypography>
        {hasRowSelection && !disableSelectedRowStatus && (
          <>
            {treeSelectionLabels ? (
              // Tree data selection - show parent and child counts separately
              // Parent count uses existing Redux selectedCount (handles selectAll/deselection correctly)
              // Child count uses manually calculated treeChildCount
              <>
                <SFTypography variant="body1bold">
                  {treeSelectionLabels.parentLabel ||
                    t("components.datagrid.footer.parentsSelected")}
                  {savedLayout?.selection?.selectedCount}
                </SFTypography>
                <SFTypography variant="body1bold">
                  {treeSelectionLabels.childLabel ||
                    t("components.datagrid.footer.childrenSelected")}
                  {savedLayout?.selection?.treeChildCount ?? 0}
                </SFTypography>
              </>
            ) : (
              // Standard selection - show single count
              <SFTypography variant="body1bold">
                {t("components.datagrid.footer.selected")}{" "}
                {savedLayout?.selection?.selectedCount}
              </SFTypography>
            )}
          </>
        )}
      </SFStack>
    </div>
  );
};

SFBottomStatusPanel.propTypes = {
  gridName: PropTypes.string.isRequired,
  hasRowSelection: PropTypes.bool,
  treeSelectionLabels: PropTypes.shape({
    parentLabel: PropTypes.string,
    childLabel: PropTypes.string,
  }),
};

export default SFBottomStatusPanel;
